// C13 · تقارير الشركة (company reports) — per-screen i18n namespace. Full ar/en
// parity for every key reports.vue binds. Merged at load time via
// require.context('./screens') in i18n.ts — no shared file is touched.
module.exports = {
  ar: {
    reports: {
      loading: 'جاري التحميل…',
      error: 'تعذّر تحميل التقارير',
      summaryUnavailable: 'تعذّر تحميل ملخّص لوحة التقارير (المعاينة والرسوم). ده مش بيمنعك من إنشاء التقارير وتنزيلها — اضغط «حاول تاني» لو عايز الملخّص.',
      retry: 'حاول تاني',
      title: 'تقارير الشركة',
      searchPh: 'بحث سريع',
      config: {
        title: 'إعداد التقرير',
        type: 'نوع التقرير',
        from: 'من تاريخ',
        to: 'إلى تاريخ',
        status: 'فلتر الحالة',
        format: 'صيغة الملف',
      },
      formats: { csv: 'CSV', xlsx: 'Excel (XLSX)', pdf: 'PDF' },
      job: {
        status: 'حالة التقرير',
        phase: { done: 'جاهز', failed: 'فشل', pending: 'قيد التجهيز', none: '—' },
      },
      errors: {
        failed: 'فشل توليد التقرير، حاول مرة أخرى.',
        download: 'تعذّر تنزيل الملف، حاول مرة أخرى.',
        network: 'تعذّر الاتصال بالخادم.',
        forbidden: 'ليس لديك صلاحية توليد التقارير.',
        invalid: 'بيانات التقرير غير صالحة.',
        generic: 'تعذّر توليد التقرير.',
      },
      types: {
        claims: 'مطالبات الموظفين',
        employees: 'الموظفين (تعداد وحالات)',
      },
      statusFilter: {
        all: 'كل الحالات',
        accepted: 'اتقبلت',
        rejected: 'اترفضت',
        review: 'تحت المراجعة',
      },
      actions: {
        generate: 'توليد التقرير',
        generating: 'جارٍ التوليد…',
        download: 'تنزيل الملف',
        downloading: 'جارٍ التنزيل…',
        pdf: 'PDF',
        excel: 'Excel',
      },
      summary: {
        title: 'ملخّص سريع',
        claims: 'مطالبة',
        acceptance: 'نسبة القبول',
        spend: 'إجمالي مصروف',
        monthlyLegend: 'التوظيف الشهري',
      },
      preview: {
        title: 'معاينة التقرير',
        rows: 'صف',
        empty: 'لا توجد بيانات مطابقة للفلاتر المختارة',
        col: {
          no: 'رقم',
          employee: 'الموظف',
          type: 'النوع',
          amount: 'المبلغ',
          date: 'التاريخ',
          status: 'الحالة',
        },
      },
      status: {
        registered: 'اتسجّلت',
        at_insurer: 'عند التأمين',
        missing_doc: 'ناقصها مستند',
        accepted: 'اتقبلت',
        rejected: 'اترفضت',
      },
      notices: {
        generated: 'تم توليد التقرير حسب الفلاتر المختارة.',
        pdf: 'يتم تجهيز ملف PDF للتقرير…',
        excel: 'يتم تجهيز ملف Excel بصيغة بيانات شركة التأمين تلقائيًا…',
      },
    },
  },
  en: {
    reports: {
      loading: 'Loading…',
      error: 'Failed to load reports',
      summaryUnavailable: 'Could not load the reports summary (the preview and charts). This does not stop you generating and downloading reports — press “Retry” if you want the summary.',
      retry: 'Retry',
      title: 'Company Reports',
      searchPh: 'Quick search',
      config: {
        title: 'Report Setup',
        type: 'Report type',
        from: 'From date',
        to: 'To date',
        status: 'Status filter',
        format: 'File format',
      },
      formats: { csv: 'CSV', xlsx: 'Excel (XLSX)', pdf: 'PDF' },
      job: {
        status: 'Report status',
        phase: { done: 'Ready', failed: 'Failed', pending: 'In progress', none: '—' },
      },
      errors: {
        failed: 'Report generation failed, please try again.',
        download: 'Could not download the file, please try again.',
        network: 'Could not reach the server.',
        forbidden: 'You do not have permission to generate reports.',
        invalid: 'The report request is invalid.',
        generic: 'Could not generate the report.',
      },
      types: {
        claims: 'Employee claims',
        employees: 'Employees (count and statuses)',
      },
      statusFilter: {
        all: 'All statuses',
        accepted: 'Accepted',
        rejected: 'Rejected',
        review: 'Under review',
      },
      actions: {
        generate: 'Generate report',
        generating: 'Generating…',
        download: 'Download file',
        downloading: 'Downloading…',
        pdf: 'PDF',
        excel: 'Excel',
      },
      summary: {
        title: 'Quick Summary',
        claims: 'claims',
        acceptance: 'Acceptance rate',
        spend: 'Total spend',
        monthlyLegend: 'Monthly hiring',
      },
      preview: {
        title: 'Report Preview',
        rows: 'rows',
        empty: 'No data matches the selected filters',
        col: {
          no: 'No.',
          employee: 'Employee',
          type: 'Type',
          amount: 'Amount',
          date: 'Date',
          status: 'Status',
        },
      },
      status: {
        registered: 'Registered',
        at_insurer: 'At insurer',
        missing_doc: 'Missing document',
        accepted: 'Accepted',
        rejected: 'Rejected',
      },
      notices: {
        generated: 'Report generated for the selected filters.',
        pdf: 'Preparing the report PDF…',
        excel: 'Preparing an Excel file in the insurer data shape automatically…',
      },
    },
  },
};
